import { IMPORT_TYPE_TRAITEMENT, DATA_ADD_LAST_DATA, STATION_INTEGRATION, DATA_REPLACE_RECENT_HISTO, DATA_ADD_NEW_DATA } from 'traitements/constants/TraitementConstants'
import { getFilterADES, getFilterERA5, getFilterHydro, getFilterMFRadar, getFilterOndes, getFilterOROBNAT, getFilterPluvio, getFilterPluvioEmprise, getParamHydro } from './FiltersTreatment'
import { push } from '@lagunovsky/redux-react-router'
import JobAction from 'import/actions/JobAction'
import ToastrAction from 'toastr/actions/ToastrAction'
import i18n from 'simple-react-i18n'

const reset = (resetStep, setStation, setFilters, setJobDataTypes) =>{
    resetStep()
    setStation({})
    setFilters({})
    setJobDataTypes([])
}

const sizeCorrect = (listStation) => {
    return listStation.some(item => item[1].length > 0)
}

const nameCorrect = (name) => !!name

const getDatatypesAndParams = (stationType, filters, listStation, options = {}) => {
    switch (stationType) {
        case IMPORT_TYPE_TRAITEMENT.PLUVIO_PORTAIL:
            return {
                filters: getFilterPluvio(filters, listStation, options),
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA],
            }
        case IMPORT_TYPE_TRAITEMENT.NAIADES :
            return {
                filters: getFilterHydro(filters, listStation, options),
                dataTypes: [STATION_INTEGRATION, DATA_REPLACE_RECENT_HISTO],
                parameters: getParamHydro(filters, listStation),
            }
        case IMPORT_TYPE_TRAITEMENT.ERA5 :
            return {
                filters: getFilterERA5(filters, listStation, options),
            }
        case IMPORT_TYPE_TRAITEMENT.PIEZO_PORTAIL :
            return {
                filters: getFilterADES(filters, listStation, options),
                dataTypes: [ STATION_INTEGRATION, DATA_ADD_NEW_DATA ],
            }
        case IMPORT_TYPE_TRAITEMENT.ADES_QUALITO :
            return {
                filters: getFilterADES(filters, listStation, options),
                dataTypes: [ STATION_INTEGRATION, DATA_ADD_NEW_DATA ],
            }
        case IMPORT_TYPE_TRAITEMENT.OROBNAT :
            return {
                filters: getFilterOROBNAT(filters, listStation, options),
                dataTypes: [ STATION_INTEGRATION, DATA_REPLACE_RECENT_HISTO ],
            }
        case IMPORT_TYPE_TRAITEMENT.PLUVIO_EMPRISE :
            return {
                filters: getFilterPluvioEmprise(filters, listStation, options),
            }
        case IMPORT_TYPE_TRAITEMENT.METEO_FRANCE_RADAR :
            return {
                filters: getFilterMFRadar(filters, listStation, options),
            }
        case IMPORT_TYPE_TRAITEMENT.LOW_WATER_ONDE :
            return {
                filters: getFilterOndes(filters, listStation, options),
            }

        case IMPORT_TYPE_TRAITEMENT.TIDE_GAUGE :
            return {
                filters: getFilterHydro(filters, listStation, options),
                dataTypes: [STATION_INTEGRATION, DATA_REPLACE_RECENT_HISTO],
                parameters: getParamHydro(filters, listStation),
            }
        default :
            return []
    }
}

const save = (listStation, newJob, STEP, step, station, filters, dispatch, setNewJob, initialJob, resetStep, setStation, setFilters, setJobDataTypes) => {
    if (step === STEP.OPTIONS && sizeCorrect(listStation) && nameCorrect(newJob.name) && station.stationType === IMPORT_TYPE_TRAITEMENT.HYDRO_PORTAIL) {
        reset(resetStep, setStation, setFilters, setJobDataTypes)
        dispatch(JobAction.addJob({
            ...newJob,
            jobType: station.stationType.toLowerCase(),
            parameters: { jobType: station.stationType.toLowerCase(),
                filters: getFilterHydro(filters, listStation),
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA,
                    'withPred', 'heightIntegration', 'debitIntegration',
                    'withEvents', 'withThresholds'],
                parameters: getParamHydro(filters, listStation),
            } }, false)).then((j) => {
            setNewJob(initialJob)
            dispatch(push(`/import/${j.id}`))
        })
    } else if (step === STEP.OPTIONS && sizeCorrect(listStation) && nameCorrect(newJob.name)) {
        const data = getDatatypesAndParams(station.stationType, filters, listStation)
        reset(resetStep, setStation, setFilters, setJobDataTypes, dispatch)
        dispatch(JobAction.addJob({
            ...newJob,
            jobType: station.stationType,
            parameters: { jobType: station.stationType,
                filters: data?.filters,
                dataTypes: data?.dataTypes,
                parameters: data?.parameters,
            } }, false)).then((j) => {
            setNewJob(initialJob)
            dispatch(push(`/import/${j.id}`))
        })
    } else {
        dispatch(ToastrAction.error(i18n.fetchError + i18n.noCodeSelectedError))
    }
}

const justsave = (listStation, newJob, jobtype, filters, dispatch) => {
    if (sizeCorrect(listStation) && nameCorrect(newJob.name) && jobtype === IMPORT_TYPE_TRAITEMENT.HYDRO_PORTAIL) {
        dispatch(JobAction.addJob({
            ...newJob,
            jobType: jobtype.toLowerCase(),
            parameters: { jobType: jobtype.toLowerCase(),
                filters: getFilterHydro(filters, listStation, { noFind: true }),
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA,
                    'withPred', 'heightIntegration', 'debitIntegration',
                    'withEvents', 'withThresholds'],
                parameters: getParamHydro(filters, listStation),
            } }, false))
    } else if (sizeCorrect(listStation) && nameCorrect(newJob.name)) {
        const data = getDatatypesAndParams(jobtype, filters, listStation, { noFind: true })
        dispatch(JobAction.addJob({
            ...newJob,
            jobType: jobtype,
            parameters: { jobType: jobtype,
                filters: data?.filters,
                dataTypes: data?.dataTypes,
                parameters: data?.parameters,
            } }, false))
    } else {
        dispatch(ToastrAction.error(i18n.fetchError + i18n.noCodeSelectedError))
    }
}

const saveAndLaunch = (listStation, newJob, jobtype, filters, dispatch) => {
    if (sizeCorrect(listStation) && nameCorrect(newJob.name) && jobtype === IMPORT_TYPE_TRAITEMENT.HYDRO_PORTAIL) {
        dispatch(JobAction.addJob({
            ...newJob,
            jobType: jobtype.toLowerCase(),
            parameters: { jobType: jobtype.toLowerCase(),
                filters: getFilterHydro(filters, listStation, { noFind: true }),
                dataTypes: [STATION_INTEGRATION, DATA_ADD_LAST_DATA,
                    'withPred', 'heightIntegration', 'debitIntegration',
                    'withEvents', 'withThresholds'],
                parameters: getParamHydro(filters, listStation),
            } }, false)).then((j) => {
            dispatch(JobAction.executeJob(j.id, 50000, () => {}))
        })
    } else if (sizeCorrect(listStation) && nameCorrect(newJob.name)) {
        const data = getDatatypesAndParams(jobtype, filters, listStation, { noFind: true })
        dispatch(JobAction.addJob({
            ...newJob,
            jobType: jobtype.toLowerCase(),
            parameters: { jobType: jobtype.toLowerCase(),
                filters: data?.filters,
                dataTypes: data?.dataTypes,
                parameters: data?.parameters,
            } }, false)).then((j) => {
            dispatch(JobAction.executeJob(j.id, 50000, () => {}))
        })
    } else {
        dispatch(ToastrAction.error(i18n.fetchError + i18n.noCodeSelectedError))
    }
}

export {
    save,
    justsave,
    saveAndLaunch,
    nameCorrect,
    sizeCorrect,
}